import { useState, useCallback, useEffect } from "react";

export default function UseInstall() {
  const [mayInstall, setMayInstall] = useState(false);

  const [deferredPrompt, setDeferredPrompt] = useState();

  useEffect(() => {
    if (`BeforeInstallPromptEvent` in window) {
      window.addEventListener(`beforeinstallprompt`, (e) => {
        e.preventDefault();
        setDeferredPrompt(e);
        setMayInstall(true);
      });
    } 
  }, []);

  const prompt = useCallback(() => {
    if (deferredPrompt) {
      deferredPrompt.prompt();

      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("installed successfully");
        } else {
          console.log("did not accept");
        }

        setDeferredPrompt(undefined);
      });
    }
  }, [deferredPrompt]);

  return [{ mayInstall, deferredPrompt }, { prompt }];
}
